import { atom } from 'recoil';

interface PlugState {
	principalId: string | null;
	isConnected: boolean;
	isLoading: boolean;
}

export const initPlugState = atom<PlugState>({
	key: 'initPlugState',
	default: {
		principalId: null,
		isConnected: false,
		isLoading: false
	}
});
